import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { routes } from "../../../helper/routes";
import edfocilogo from "../../../assets/images/logo.png";
import edsiderlogowhite from "../../../assets/images/edsiderlogowhite.png"
import cmclogo from "../../../assets/images/mid.png"
import RAlogo from "../../../assets/images/royal-logo.png"
import CGClogo from "../../../assets/images/cgc-logo.png";
import { HiBellAlert, HiShoppingCart } from 'react-icons/hi2';
import './sidebar.css';
import config from '../../../helper/config';
import { customerConstants } from "../../../helper/constants.js";
import NotificationDropdown from './NotificationDropdown.js';
import { useCart } from '../../../context/cart/CartContext';

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};
const customer = getCustomerFeatureFlag();
let logo, logoStyle;

switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    logo = edsiderlogowhite;
    logoStyle = { width: "140px", height: "auto" };
    break;
  case customerConstants.EXO_CUSTOMER2:
    logo = cmclogo;
    logoStyle = { width: "140px", height: "auto" };
    break;
  case customerConstants.EDF_CUSTOMER2:
    logo = RAlogo;
    logoStyle = { width: "40px", height: "auto" };
    break;
  case customerConstants.EDF_CUSTOMER3:
    logo = CGClogo;
    logoStyle = { width: "40px", height: "auto" };
    break;
  default:
    logo = edfocilogo;
    logoStyle = { width: "140px", height: "auto" };
    break;
}

export default function HeaderMobile(props) {

  const history = useHistory();
  const { cartItemCount } = useCart();
  const [isNotificationsOpen, setNotificationsOpen] = useState(false);
  const isTeacher = sessionStorage.getItem("userType") === "teacher";

  useEffect(() => {
    if (window.KTLayoutAside) window.KTLayoutAside.init('kt_aside');
  }, []);

  const toggleNotifications = () => {
    setNotificationsOpen(!isNotificationsOpen);
  };

  const goToCart = () => {
    if (props.isExamMode) return;
    history.push(routes.my_cart);
  };

  const goToProfile = () => {
    if (props.isExamMode) return;
    history.push(routes.profile);
  };

  return (
    <div style={{ position: 'relative' }}>

      <div id="kt_header_mobile" className="header-mobile align-items-center header-mobile-fixed" >
        <div className="brand-logo">
          <img alt="Logo" className="logo" src={logo} />
        </div>
        <div className="d-flex align-items-center">
          {!props.isExamMode && !isTeacher && (
            <button
              className="tmh-icon-btn ml-2 cart-icon"
              id="kt_header_mobile_cart_toggle"
              onClick={goToCart}
              aria-label="Open cart"
              title="Cart"
            >
              <HiShoppingCart className="tmh-icon cart-icon__icon" />
              {cartItemCount > 0 && (
                <span className="cart-badge">{cartItemCount > 99 ? '99+' : cartItemCount}</span>
              )}
            </button>
          )}

          {!props.isExamMode && (
            <button
              className="tmh-icon-btn tmh-notification-btn ml-2 notification-icon"
              id="kt_header_mobile_notifications_toggle"
              onClick={toggleNotifications}
              aria-label="Open notifications"
              title="Notifications"
            >
              <HiBellAlert className="tmh-icon notification-icon__icon" />
            </button>
          )}

          {!props.isExamMode && (
            <button
              className="tmh-icon-btn"
              id="kt_header_mobile_toggle"
              onClick={props.onMobileMenuToggle}
            >
              <svg
                className="tmh-icon"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                aria-hidden="true"
              >
                <path d="M3 6h18v2H3zM3 11h18v2H3zM3 16h18v2H3z"></path>
              </svg>
            </button>
          )}

          {!props.isExamMode && (
            <button
              className="tmh-icon-btn tmh-profile-btn  ml-2"
              id="kt_header_mobile_topbar_toggle"
              onClick={goToProfile}
              aria-label="Open profile"
              title="Profile"
            >
              {/* Profile/user icon (SVG) */}
              <svg
                className="tmh-icon"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                aria-hidden="true"
              >
                <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5z"></path>
              </svg>
            </button>
          )}

        </div>
      </div>

      {/* Notifications dropdown for mobile */}
      <NotificationDropdown
        isOpen={isNotificationsOpen}
        onClose={() => setNotificationsOpen(false)}
      />
    </div>
  )
}
